var map = {
	"./bg-BG.json": [
		"./src/lang/bg-BG.json",
		"i18n0"
	],
	"./cs-CZ.json": [
		"./src/lang/cs-CZ.json",
		"i18n1"
	],
	"./da-DK.json": [
		"./src/lang/da-DK.json",
		"i18n2"
	],
	"./de-DE.json": [
		"./src/lang/de-DE.json",
		"i18n3"
	],
	"./el-GR.json": [
		"./src/lang/el-GR.json",
		"i18n4"
	],
	"./en-US.json": [
		"./src/lang/en-US.json",
		"i18n5"
	],
	"./es-ES.json": [
		"./src/lang/es-ES.json",
		"i18n6"
	],
	"./et-EE.json": [
		"./src/lang/et-EE.json",
		"i18n7"
	],
	"./fi-FI.json": [
		"./src/lang/fi-FI.json",
		"i18n8"
	],
	"./fr-FR.json": [
		"./src/lang/fr-FR.json",
		"i18n9"
	],
	"./hr-HR.json": [
		"./src/lang/hr-HR.json",
		"i18n10"
	],
	"./hu-HU.json": [
		"./src/lang/hu-HU.json",
		"i18n11"
	],
	"./is-IS.json": [
		"./src/lang/is-IS.json",
		"i18n12"
	],
	"./it-IT.json": [
		"./src/lang/it-IT.json",
		"i18n13"
	],
	"./lt-LT.json": [
		"./src/lang/lt-LT.json",
		"i18n14"
	],
	"./lv-LV.json": [
		"./src/lang/lv-LV.json",
		"i18n15"
	],
	"./nb-NO.json": [
		"./src/lang/nb-NO.json",
		"i18n16"
	],
	"./nl-NL.json": [
		"./src/lang/nl-NL.json",
		"i18n17"
	],
	"./pl-PL.json": [
		"./src/lang/pl-PL.json",
		"i18n18"
	],
	"./pt-BR.json": [
		"./src/lang/pt-BR.json",
		"i18n19"
	],
	"./pt-PT.json": [
		"./src/lang/pt-PT.json",
		"i18n20"
	],
	"./ro-RO.json": [
		"./src/lang/ro-RO.json",
		"i18n21"
	],
	"./ru-RU.json": [
		"./src/lang/ru-RU.json",
		"i18n22"
	],
	"./sk-SK.json": [
		"./src/lang/sk-SK.json",
		"i18n23"
	],
	"./sv-SE.json": [
		"./src/lang/sv-SE.json",
		"i18n24"
	],
	"./tr-TR.json": [
		"./src/lang/tr-TR.json",
		"i18n25"
	],
	"./zh-CN.json": [
		"./src/lang/zh-CN.json",
		"i18n26"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/lang lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;